import { useHistory } from 'react-router-dom';
import { useSessionContext } from 'contexts/sessionProvider/SessionProvider';
import { useGetProductData } from 'hooks/useGetProductData';
import { useGetQuoteData } from 'hooks/useGetQuote/useGetQuoteData';
import { useFeatureToggleContext } from 'providers/featureToggleProvider/FeatureToggleProvider';
import { FEATURE_TOGGLE, SUBSCRIPTION_TYPE } from '../../constants';
import { mapQuoteToProductData } from '../../utils/mapQuoteToProductData';
import { ProductData, UseGetProductDataType } from './types';

export const useGetProduct = (): UseGetProductDataType => {
  const history = useHistory();
  const { isFeatureEnabled } = useFeatureToggleContext();
  const {
    productId,
    promoCode,
    pc,
    activationCode,
    subscriptionType,
    quoteId,
    addonIds
  } = useSessionContext();
  const isQuoteApiUpliftEnabled = isFeatureEnabled(FEATURE_TOGGLE.QUOTE_API_UPLIFT);
  const isQuoteFlow = subscriptionType === SUBSCRIPTION_TYPE.QUOTE && isQuoteApiUpliftEnabled;

  const {
    data: quoteData,
    isLoading: isQuoteLoading,
    isError: isQuoteError,
    isSuccess: isQuoteSuccess
  } = useGetQuoteData(isQuoteFlow ? quoteId : undefined);

  const {
    productData: catalogProductData,
    isLoading: isCatalogLoading,
    isError: isCatalogError,
    isSuccess: isCatalogSuccess
  } = useGetProductData({
    productId,
    promoCode: promoCode || pc,
    activationCode,
    enabled: !isQuoteFlow
  });

  if (isQuoteFlow) {
    if (isQuoteError) {
      history.push('/error');
    }
    const productData: ProductData = quoteData && productId ?
      mapQuoteToProductData(quoteData, productId, addonIds) :
      {} as ProductData;

    return {
      productData,
      isLoading: isQuoteLoading,
      isError: isQuoteError,
      isSuccess: isQuoteSuccess && Boolean(quoteData) && Boolean(productId)
    };
  }

  if (isCatalogError) {
    history.push('/error');
  }
  return {
    productData: catalogProductData,
    isLoading: isCatalogLoading,
    isError: isCatalogError,
    isSuccess: isCatalogSuccess
  };
};
